import { Dispatch } from "redux";
import { PostComment } from "../../../domain/entities/Chat";
import Document from "../../../domain/entities/Document";
import Message from "../../../domain/entities/Message";
import Signatory from "../../../domain/entities/Signatory";
import User from "../../../domain/entities/User";
import SignatoryInteractor from "../../../domain/interactors/SignatoryInteractor";
import { SignatoryRecord } from "../../components/pages/student-history";
import { RootState } from "../reducers";
import Payment from "../../../domain/entities/Payment";

export enum ActionTypes {
  DOCUMENTS_RESTORE_STATES = "@signatory/DOCUMENTS_RESTORE_STATES",
  DOCUMENT_CLEAN_VALUE = "@signatory/DOCUMENT_CLEAN_VALUE",
  DOCUMENTS_CLEAN_VALUE = "@signatory/DOCUMENTS_CLEAN_VALUE",
  DOCUMENTS_LOAD_PROCESSING = "@signatory/DOCUMENTS_LOAD_PROCESSING",
  DOCUMENTS_LOAD_COMPLETE = "@signatory/DOCUMENTS_LOAD_COMPLETE",
  DOCUMENTS_LOAD_ERROR = "@signatory/DOCUMENTS_LOAD_ERROR",
  DOCUMENT_SAVE_PROCESSING = "@signatory/DOCUMENT_SAVE_PROCESSING",
  DOCUMENT_SAVE_COMPLETE = "@signatory/DOCUMENT_SAVE_COMPLETE",
  DOCUMENT_SAVE_ERROR = "@signatory/DOCUMENT_SAVE_ERROR",
  DOCUMENT_LOAD_PROCESSING = "@signatory/DOCUMENT_LOAD_PROCESSING",
  DOCUMENT_LOAD_COMPLETE = "@signatory/DOCUMENT_LOAD_COMPLETE",
  DOCUMENT_LOAD_ERROR = "@signatory/DOCUMENT_LOAD_ERROR",
  DOCUMENT_SIGN_PROCESSING = "@signatory/DOCUMENT_SIGN_PROCESSING",
  DOCUMENT_SIGN_COMPLETE = "@signatory/DOCUMENT_SIGN_COMPLETE",
  DOCUMENT_SIGN_ERROR = "@signatory/DOCUMENT_SIGN_ERROR",
  DOCUMENT_RESEND_PROCESSING = "@signatory/DOCUMENT_RESEND_PROCESSING",
  DOCUMENT_RESEND_COMPLETE = "@signatory/DOCUMENT_RESEND_COMPLETE",
  DOCUMENT_RESEND_ERROR = "@signatory/DOCUMENT_RESEND_ERROR",
  DOCUMENT_SENDBACK_PROCESSING = "@signatory/DOCUMENT_SENDBACK_PROCESSING",
  DOCUMENT_SENDBACK_COMPLETE = "@signatory/DOCUMENT_SENDBACK_COMPLETE",
  DOCUMENT_SENDBACK_ERROR = "@signatory/DOCUMENT_SENDBACK_ERROR",
  DOCUMENT_SAVE_PROGRESS_PROCESSING = "@signatory/DOCUMENT_SAVE_PROGRESS_PROCESSING",
  DOCUMENT_SAVE_PROGRESS_COMPLETE = "@signatory/DOCUMENT_SAVE_PROGRESS_COMPLETE",
  DOCUMENT_SAVE_PROGRESS_ERROR = "@signatory/DOCUMENT_SAVE_PROGRESS_ERROR",
  SIGNATORY_SAVE_COMPLETE = "@signatory/SIGNATORY_SAVE_COMPLETE",
  SIGNATORY_SAVE_ERROR = "@signatory/SIGNATORY_SAVE_ERROR",
  SIGNATORY_SAVE_PROCESSING = "@signatory/SIGNATORY_SAVE_PROCESSING",
  SIGNATORY_LOAD_BY_EMAIL_PROCESSING = "@signatory/SIGNATORY_LOAD_BY_EMAIL_PROCESSING",
  SIGNATORY_LOAD_BY_EMAIL_COMPLETE = "@signatory/SIGNATORY_LOAD_BY_EMAIL_COMPLETE",
  SIGNATORY_LOAD_BY_EMAIL_ERROR = "@signatory/SIGNATORY_LOAD_BY_EMAIL_ERROR",
  SIGNATORY_AUTH_LOAD_BY_EMAIL_PROCESSING = "@signatory/SIGNATORY_AUTH_LOAD_BY_EMAIL_PROCESSING",
  SIGNATORY_AUTH_LOAD_BY_EMAIL_COMPLETE = "@signatory/SIGNATORY_AUTH_LOAD_BY_EMAIL_COMPLETE",
  SIGNATORY_AUTH_LOAD_BY_EMAIL_ERROR = "@signatory/SIGNATORY_AUTH_LOAD_BY_EMAIL_ERROR",
  SIGNATORY_RECORD_SAVE_PROCESSING = "@signatory/SIGNATORY_RECORD_SAVE_PROCESSING",
  SIGNATORY_RECORD_SAVE_COMPLETE = "@signatory/SIGNATORY_RECORD_SAVE_COMPLETE",
  SIGNATORY_RECORD_SAVE_ERROR = "@signatory/SIGNATORY_RECORD_SAVE_ERROR",
  SIGNATORY_RECORDS_LOAD_PROCESSING = "@signatory/SIGNATORY_RECORDS_LOAD_PROCESSING",
  SIGNATORY_RECORDS_LOAD_COMPLETE = "@signatory/SIGNATORY_RECORDS_LOAD_COMPLETE",
  SIGNATORY_RECORDS_LOAD_ERROR = "@signatory/SIGNATORY_RECORDS_LOAD_ERROR",
  DOCUMENT_LOAD_BY_CAMPAIGN_PROCESSING = "@signatory/DOCUMENT_LOAD_BY_CAMPAIGN_PROCESSING",
  DOCUMENT_LOAD_BY_CAMPAIGN_COMPLETE = "@signatory/DOCUMENT_LOAD_BY_CAMPAIGN_COMPLETE",
  DOCUMENT_LOAD_BY_CAMPAIGN_ERROR = "@signatory/DOCUMENT_LOAD_BY_CAMPAIGN_ERROR",
  PDF_TRANSLATE_PROCESSING = "@signatory/PDF_TRANSLATE_PROCESSING",
  PDF_TRANSLATE_COMPLETE = "@signatory/PDF_TRANSLATE_COMPLETE",
  PDF_TRANSLATE_ERROR = "@signatory/PDF_TRANSLATE_ERROR",
  CHAT_SAVE_PROCESSING = "@signatory/CHAT_SAVE_PROCESSING",
  CHAT_SAVE_COMPLETE = "@signatory/CHAT_SAVE_COMPLETE",
  CHAT_SAVE_ERROR = "@signatory/CHAT_SAVE_ERROR",
  CHAT_DELETE_PROCESSING = "@requestor/CHAT_DELETE_PROCESSING",
  CHAT_DELETE_COMPLETE = "@requestor/CHAT_DELETE_COMPLETE",
  CHAT_DELETE_ERROR = "@requestor/CHAT_DELETE_ERROR",
  CHATS_LOAD_PROCESSING = "@signatory/CHATS_LOAD_PROCESSING",
  CHATS_LOAD_COMPLETE = "@signatory/CHATS_LOAD_COMPLETE",
  CHATS_LOAD_ERROR = "@signatory/CHATS_LOAD_ERROR",
  FULLURL_PROCESSING = "@signatory/FULLURL_PROCESSING",
  FULLURL_COMPLETE = "@signatory/FULLURL_COMPLETE",
  FULLURL_ERROR = "@signatory/FULLURL_ERROR",
  COLLECTIVE_SIGNATORY_UPDATE = "@signatory/COLLECTIVE_SIGNATORY_UPDATE",
  COLLECTIVE_DOCUMENTS_UPDATE = "@signatory/COLLECTIVE_DOCUMENTS_UPDATE",
  COLLECTIVE_MESSAGES_UPDATE = "@signatory/COLLECTIVE_MESSAGES_UPDATE",
  COLLECTIVE_DATA_UPDATE = "@signatory/COLLECTIVE_DATA_UPDATE",
  PAYMENTS_CLEAN_VALUE = "@signatory/PAYMENTS_CLEAN_VALUE",
  PAYMENTS_RESTORE_STATES = "@signatory/PAYMENTS_RESTORE_STATES",
  PAYMENT_SAVE_PROCESSING = "@signatory/PAYMENT_SAVE_PROCESSING",
  PAYMENT_SAVE_COMPLETE = "@signatory/PAYMENT_SAVE_COMPLETE",
  PAYMENT_SAVE_ERROR = "@signatory/PAYMENT_SAVE_ERROR",
  PAYMENT_LOAD_PROCESSING = "@signatory/PAYMENT_LOAD_PROCESSING",
  PAYMENT_LOAD_COMPLETE = "@signatory/PAYMENT_LOAD_COMPLETE",
  PAYMENT_LOAD_ERROR = "@signatory/PAYMENT_LOAD_ERROR",
  PAYMENTS_LOAD_PROCESSING = "@signatory/PAYMENTS_LOAD_PROCESSING",
  PAYMENTS_LOAD_COMPLETE = "@signatory/PAYMENTS_LOAD_COMPLETE",
  PAYMENTS_LOAD_ERROR = "@signatory/PAYMENTS_LOAD_ERROR",
  PAYMENTS_COUNT_CLEAN = "@signatory/PAYMENTS_COUNT_CLEAN",
  PAYMENTS_COUNT_LOAD_COMPLETE = "@requestor/PAYMENTS_COUNT_LOAD_COMPLETE",
  PAYMENTS_COUNT_LOAD_ERROR = "@requestor/PAYMENTS_COUNT_LOAD_ERROR",
  PAYMENTS_COUNT_LOAD_PROCESSING = "@requestor/PAYMENTS_COUNT_LOAD_PROCESSING",
  PAYMENTS_PAGINATION_LOAD_PROCESSING = "@requestor/PAYMENTS_PAGINATION_LOAD_PROCESSING",
  PAYMENTS_PAGINATION_LOAD_COMPLETE = "@requestor/PAYMENTS_PAGINATION_LOAD_COMPLETE",
  PAYMENTS_PAGINATION_LOAD_ERROR = "@requestor/PAYMENTS_PAGINATION_LOAD_ERROR",
  LASTVALUEKEY_CLEAN = "@requestor/LASTVALUEKEY_CLEAN",
  PAYMENT_SUCCESS_COMPLETE = "@session/PAYMENT_SUCCESS_COMPLETE",
  PAYMENT_SUCCESS_ERROR = "@session/PAYMENT_SUCCESS_ERROR",
  PAYMENT_SUCCESS_PROCESSING = "@session/PAYMENT_SUCCESS_PROCESSING",
  PDF_ESIGN_AUDIT_COMPLETE = "@session/PDF_ESIGN_AUDIT_COMPLETE",
  PDF_ESIGN_COMPLETE = "@session/PDF_ESIGN_COMPLETE",
  PDF_ESIGN_ERROR = "@session/PDF_ESIGN_ERROR",
  PDF_ESIGN_PROCESSING = "@session/PDF_ESIGN_PROCESSING",
  ATTACHMENT_SAVE_COMPLETE = "@session/ATTACHMENT_SAVE_COMPLETE",
  ATTACHMENT_SAVE_ERROR = "@session/ATTACHMENT_SAVE_ERROR",
  ATTACHMENT_SAVE_PROCESSING = "@session/ATTACHMENT_SAVE_PROCESSING",
  ATTACHMENT_LOAD_COMPLETE = "@session/ATTACHMENT_LOAD_COMPLETE",
  ATTACHMENT_LOAD_ERROR = "@session/ATTACHMENT_LOAD_ERROR",
  ATTACHMENT_LOAD_PROCESSING = "@session/ATTACHMENT_LOAD_PROCESSING",
}

export const restoreDocument = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.DOCUMENTS_RESTORE_STATES });
  };
};

export const cleanDocuments = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.DOCUMENTS_CLEAN_VALUE });
  };
};

export const cleanDocument = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.DOCUMENT_CLEAN_VALUE });
  };
};

export const cleanLastValueKey = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.LASTVALUEKEY_CLEAN });
  };
};

export const saveDocument = (document: Document) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENT_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.DOCUMENT_SAVE_COMPLETE,
        payload: await deps.signatoryInteractor.saveDocument(document),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.DOCUMENT_SAVE_ERROR, payload: error });
    }
  };
};

export const saveDocumentRecord = (document: Document) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENT_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.DOCUMENT_SAVE_COMPLETE,
        payload: await deps.signatoryInteractor.saveDocumentRecord(document),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.DOCUMENT_SAVE_ERROR, payload: error });
    }
  };
};

export const loadDocument = (organizationId: string, documentId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENT_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.DOCUMENT_LOAD_COMPLETE,
        payload: await deps.signatoryInteractor.getDocument(
          organizationId,
          documentId
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.DOCUMENT_LOAD_ERROR, payload: error });
    }
  };
};

export const loadDocumentExt = (shortId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENT_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.DOCUMENT_LOAD_COMPLETE,
        payload: await deps.signatoryInteractor.getDocumentExt(shortId),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.DOCUMENT_LOAD_ERROR, payload: error });
    }
  };
};

export const saveDocumentAction = (document: Document) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENT_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.DOCUMENT_SAVE_COMPLETE,
        payload: await deps.signatoryInteractor.saveDocumentAction(document),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.DOCUMENT_SAVE_ERROR, payload: error });
    }
  };
};

export const saveDocumentProgress = (
  organizationId: string,
  documentId: string,
  attachmentsString: string,
  signature: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENT_SAVE_PROGRESS_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.DOCUMENT_SAVE_PROGRESS_COMPLETE,
        payload: await deps.signatoryInteractor.saveDocumentProgress(
          organizationId,
          documentId,
          attachmentsString,
          signature
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.DOCUMENT_SAVE_PROGRESS_ERROR, payload: error });
    }
  };
};

export const signDocument = (
  user: User | Signatory,
  organizationId: string,
  documentId: string,
  signature: string,
  formData: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENT_SIGN_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.DOCUMENT_SIGN_COMPLETE,
        payload: await deps.signatoryInteractor.signDocument(
          user,
          organizationId,
          documentId,
          signature,
          formData
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.DOCUMENT_SIGN_ERROR, payload: error });
    }
  };
};

export const externalSignDocument = (
  shortId: string,
  signature: string,
  formData: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENT_SIGN_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.DOCUMENT_SIGN_COMPLETE,
        payload: {
          id: await deps.signatoryInteractor.externalSignDocument(
            shortId,
            signature,
            formData
          ),
          email: shortId,
        },
      });
    } catch (error) {
      dispatch({ type: ActionTypes.DOCUMENT_SIGN_ERROR, payload: error });
    }
  };
};

export const loadSignatoryDocuments = (
  organizationId: string,
  signatoryId: string,
  downloadFile: boolean
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENTS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.DOCUMENTS_LOAD_COMPLETE,
        payload: await deps.signatoryInteractor.getSignatoryDocuments(
          organizationId,
          signatoryId,
          downloadFile
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.DOCUMENTS_LOAD_ERROR, payload: error });
    }
  };
};

export const resendDocument = (user: User, documentId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENT_RESEND_PROCESSING });
    try {
      const result = await deps.signatoryInteractor.resendDocument(user, documentId);
      dispatch({
        type: ActionTypes.DOCUMENT_RESEND_COMPLETE,
        payload: result,
      });
      return result;
    } catch (error) {
      dispatch({ type: ActionTypes.DOCUMENT_RESEND_ERROR, payload: error });
      throw error;
    }
  };
};

export const sendBackDocument = (user: User, documentId: string, reason: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENT_SENDBACK_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.DOCUMENT_SENDBACK_COMPLETE,
        payload: await deps.signatoryInteractor.sendBackDocument(user, documentId, reason),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.DOCUMENT_SENDBACK_ERROR, payload: error });
    }
  };
};

export const loadRequestorDocuments = (
  organizationId: string,
  requestorId: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENTS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.DOCUMENTS_LOAD_COMPLETE,
        payload: await deps.signatoryInteractor.getRequestorDocuments(
          organizationId,
          requestorId
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.DOCUMENTS_LOAD_ERROR, payload: error });
    }
  };
};

export const loadDocTemplateByCampaign = (
  userId: string,
  organizationId: string,
  campaignId: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({
      type: ActionTypes.DOCUMENT_LOAD_BY_CAMPAIGN_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.DOCUMENT_LOAD_BY_CAMPAIGN_COMPLETE,
        payload: await deps.signatoryInteractor.loadDocTemplateByCampaign(
          userId,
          organizationId,
          campaignId
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.DOCUMENT_LOAD_BY_CAMPAIGN_ERROR,
        payload: error,
      });
    }
  };
}; 

export const saveSignatory = (signatory: Signatory) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.SIGNATORY_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SIGNATORY_SAVE_COMPLETE,
        payload: await deps.signatoryInteractor.saveSignatory(signatory),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.SIGNATORY_SAVE_ERROR, payload: error });
    }
  };
};

export const saveLanguageSignatory = (language: string, signatoryEmail: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.SIGNATORY_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SIGNATORY_SAVE_COMPLETE,
        payload: await deps.signatoryInteractor.saveLanguageSignatory(language, signatoryEmail),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.SIGNATORY_SAVE_ERROR, payload: error });
    }
  };
};

export const loadSignatoryByShortId = (shortId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.SIGNATORY_LOAD_BY_EMAIL_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SIGNATORY_LOAD_BY_EMAIL_COMPLETE,
        payload: await deps.signatoryInteractor.getSignatoryByShortId(shortId),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.SIGNATORY_LOAD_BY_EMAIL_ERROR,
        payload: error,
      });
    }
  };
};

export const loadSignatoryByEmail = (email: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.SIGNATORY_LOAD_BY_EMAIL_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SIGNATORY_LOAD_BY_EMAIL_COMPLETE,
        payload: await deps.signatoryInteractor.getSignatoryByEmail(email),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.SIGNATORY_LOAD_BY_EMAIL_ERROR,
        payload: error,
      });
    }
  };
};

export const translatePDF = (documentTemplateId: string, language: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.PDF_TRANSLATE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.PDF_TRANSLATE_COMPLETE,
        payload: await deps.signatoryInteractor.translatePDF(
          documentTemplateId,
          language
        ),
      });
    } catch (error) {
      console.log("ERROR", error);
      dispatch({
        type: ActionTypes.PDF_TRANSLATE_ERROR,
        payload: error,
      });
    }
  };
};

export const saveChat = (
  campaignId: string,
  signatoryEmail: string,
  chat: PostComment
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.CHAT_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CHAT_SAVE_COMPLETE,
        payload: await deps.signatoryInteractor.saveChat(
          campaignId,
          signatoryEmail,
          chat
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.CHAT_SAVE_ERROR,
        payload: error,
      });
    }
  };
};

export const loadChats = (campaignId: string, signatoryEmail: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.CHATS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CHATS_LOAD_COMPLETE,
        payload: await deps.signatoryInteractor.getChats(
          campaignId,
          signatoryEmail
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.CHATS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadChatsExt = (shortId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.CHATS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CHATS_LOAD_COMPLETE,
        payload: await deps.signatoryInteractor.getChatsExt(shortId),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.CHATS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadAllChats = (campaignIds: string[], signatoryEmail: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.CHATS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CHATS_LOAD_COMPLETE,
        payload: await deps.signatoryInteractor.getAllChats(
          campaignIds,
          signatoryEmail
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.CHATS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const deleteChat = (
  campaignId: string,
  signatoryEmail: string,
  chatId: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.CHAT_DELETE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CHAT_DELETE_COMPLETE,
        payload: await deps.signatoryInteractor.deleteChat(
          campaignId,
          signatoryEmail,
          chatId
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.CHAT_DELETE_ERROR,
        payload: error,
      });
    }
  };
};

export const getFullUrlByShortId = (
  campaignId: string,
  signatoryEmail: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.FULLURL_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.FULLURL_COMPLETE,
        payload: await deps.signatoryInteractor.getChats(
          campaignId,
          signatoryEmail
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.FULLURL_ERROR,
        payload: error,
      });
    }
  };
};

export const updateCollectiveSelectedSignatory = (selectedSignatory: Signatory | undefined) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ActionTypes.COLLECTIVE_SIGNATORY_UPDATE,
      payload: selectedSignatory,
    });
  };
};

export const updateCollectiveDocuments = (documents: Document[] | null) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ActionTypes.COLLECTIVE_DOCUMENTS_UPDATE,
      payload: documents,
    });
  };
};

export const updateCollectiveMessages = (messages: Message[] | null) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ActionTypes.COLLECTIVE_MESSAGES_UPDATE,
      payload: messages,
    });
  };
};

export const updateCollectiveData = (data: SignatoryRecord[] | null) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ActionTypes.COLLECTIVE_DATA_UPDATE,
      payload: data,
    });
  };
};

export const cleanPayments = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.PAYMENTS_CLEAN_VALUE });
  };
};

export const restorePayment = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.PAYMENTS_RESTORE_STATES });
  };
};

export const savePayment = (payment: Payment) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.PAYMENT_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.PAYMENT_SAVE_COMPLETE,
        payload: await deps.signatoryInteractor.savePayment(payment),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.PAYMENT_SAVE_ERROR, payload: error });
    }
  };
};

export const successPayment = (paymentId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.PAYMENT_SUCCESS_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.PAYMENT_SUCCESS_COMPLETE,
        payload: await deps.signatoryInteractor.successPayment(paymentId),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.PAYMENT_SUCCESS_ERROR, payload: error });
    }
  };
};

export const loadPayment = (paymentId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.PAYMENT_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.PAYMENT_LOAD_COMPLETE,
        payload: await deps.signatoryInteractor.getPayment(
          paymentId,
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.PAYMENT_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadPayments = (organizationId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.PAYMENTS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.PAYMENTS_LOAD_COMPLETE,
        payload: await deps.signatoryInteractor.getPayments(
          organizationId,
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.PAYMENTS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const cleanPaymentsCount = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.PAYMENTS_COUNT_CLEAN });
  };
};

export const loadPaymentsLookupsCount = (
  user: User,
  lookupType: string,
  lookupValue: string,
  statusFilter?: string,
  dateRange?: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.PAYMENTS_COUNT_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.PAYMENTS_COUNT_LOAD_COMPLETE,
        payload: await deps.signatoryInteractor.getPaymentsLookupsCount(
          user,
          lookupType,
          lookupValue,
          statusFilter,
          dateRange
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.PAYMENTS_COUNT_LOAD_ERROR, payload: error });
    }
  };
};

export const loadPaymentsByLookupPagination = (
  user: User,
  lookupType: string,
  lookupValue: string,
  pageSize: number,
  statusFilter?: string,
  dateRange?: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    const { lastEvaluatedKey, payments } = getState().signatory;

    const existingMessageIds =
      payments && payments?.length > 0 ? payments.map((p: Payment) => p.id) : undefined;

    dispatch({ type: ActionTypes.PAYMENTS_PAGINATION_LOAD_PROCESSING });
    try {
      const response =
        await deps.signatoryInteractor.getPaymentsByLookupPagination(
          user,
          lookupType,
          lookupValue,
          pageSize,
          lastEvaluatedKey,
          existingMessageIds,
          statusFilter,
          dateRange
        );

      dispatch({
        type: ActionTypes.PAYMENTS_PAGINATION_LOAD_COMPLETE,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.PAYMENTS_PAGINATION_LOAD_ERROR,
        payload: error,
      });
    }
  };
};
export const downloadPDF = (
  organizationId: string,
  userId: string,
  documentId: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.PDF_ESIGN_PROCESSING });
    try {
      const result = await deps.signatoryInteractor.downloadPDF(
        organizationId,
        userId,
        documentId
      );
      dispatch({
        type: ActionTypes.PDF_ESIGN_COMPLETE,
        payload: result,
      });
    } catch (error) {
      console.log("ERROR", error);
      dispatch({ type: ActionTypes.PDF_ESIGN_ERROR, payload: error });
    }
  };
};

export const downloadPDFwithAuditSummary = (
  organizationId: string,
  userId: string,
  documentId: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.PDF_ESIGN_PROCESSING });
    try {
      const result = await deps.signatoryInteractor.downloadPDFwithAuditSummary(
        organizationId,
        userId,
        documentId
      );
      dispatch({
        type: ActionTypes.PDF_ESIGN_AUDIT_COMPLETE,
        payload: {
          signedDocumentPdf: result.signedDocumentPdf,
          auditSummaryPdf: result.auditSummaryPdf,
        },
      });
    } catch (error) {
      console.log("ERROR", error);
      dispatch({ type: ActionTypes.PDF_ESIGN_ERROR, payload: error });
    }
  };
};

export const saveAttachment = (
  documentId: string,
  attachmentId: string,
  attachmentFile: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.ATTACHMENT_SAVE_PROCESSING });
    try {
      const result = await deps.signatoryInteractor.saveAttachment(
        documentId,
        attachmentId,
        attachmentFile
      );
      dispatch({
        type: ActionTypes.ATTACHMENT_SAVE_COMPLETE,
        payload: result,
      });
    } catch (error) {
      console.log("ERROR", error);
      dispatch({ type: ActionTypes.ATTACHMENT_SAVE_ERROR, payload: error });
    }
  };
};

export const loadAttachment = (
  documentId: string,
  attachmentId: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { signatoryInteractor: SignatoryInteractor }
  ) => {
    dispatch({ type: ActionTypes.ATTACHMENT_LOAD_PROCESSING });
    try {
      const result = await deps.signatoryInteractor.getAttachment(
        documentId,
        attachmentId
      );
      dispatch({
        type: ActionTypes.ATTACHMENT_LOAD_COMPLETE,
        payload: result,
      });
    } catch (error) {
      console.log("ERROR", error);
      dispatch({ type: ActionTypes.ATTACHMENT_LOAD_ERROR, payload: error });
    }
  };
};